<template>
	<NoSsr />
</template>

<script>
// eslint-disable-next-line import/extensions,import/no-unresolved,import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import NoSsr from './client-only';

import _pick from 'lodash/pick';

export default {
	name: 'SetRendered',
	components: {
		NoSsr
	},
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		const paramsToPick = ['module_settings.metadata_section.i_chronicle_id',
			'module_settings.metadata_section.wbmd_publ.wbmd_publ_name',
			'module_data.content_section.cons_slideshow.title',
			'module_data.content_section.cons_slideshow.slide_group'];
		const ssType = this.data.module_data.content_section.cons_slideshow.slide_type_master;

		if (ssType === 'No Image') {
			paramsToPick.push('module_data.content_section.cons_slideshow.slide_type_master');
		}

		const moduleData = _pick(this.data, paramsToPick);

		const slideData = moduleData.module_data.content_section.cons_slideshow.slide_group;

		moduleData.module_data.content_section.cons_slideshow.slide_group = slideData.map((obj) => _pick(obj, ['slide_caption_title',
			'slide_caption_text.#cdata-section',
			'slide_type_child',
			'slide_img.path']));

		this.store.cms.UPDATE_STATE({ key: this.chronicId, value: moduleData });
		this.store.cms.SET_RENDERED('091e9c5e8195baff');
	},
};
</script>

<style scoped>
</style>
